// extracted by mini-css-extract-plugin
export default {"gradient-border":"MediaItem_gradient-border__ymAVK","play-button":"MediaItem_play-button__dHgdr"};